import React, { useContext, useEffect, useState } from 'react';
import './workingTime.css';
import ItemList from '../../components/sections/itemList';

import DateRangeSelector from '../../components/sections/dateRangeSelector';
import Loader from '../../components/loader';
import { extractReport0Data, extractReport1Data, formatDateRange, processData, subtractDays } from '../../utils/generalFunctions';
import RetryReport from '../../components/retryReport';
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { DateContext } from '../../context/dateProvider';

const WorkingTime = ({ dataReport, devices, updateDevices, progress, error, fetchReport, userConstants, updateUserConstants, isRecoveredReports }) => {
    const { startDate, endDate, today,
        yesterday,
        startActualWeek,
        endActualWeek,
        startPreviousWeek,
        endPreviousWeek,
        startActualMonth,
        endActualMonth,
        startPreviousMonth,
        endPreviousMonth,
    } = useContext(DateContext);

    const [isLoading, setIsLoading] = useState(true);
    const [totalTripsData, setTotalTripsData] = useState(isRecoveredReports && userConstants.reports && userConstants.reports.foundReports ? userConstants.reports.workingTimeTripsTotalData : []);
    const [totalEventsData, setTotalEventsData] = useState(isRecoveredReports && userConstants.reports && userConstants.reports.foundReports ? userConstants.reports.workingTimeEventsTotalData : []);

    const [showAllEarlyTop, setShowAllEarlyTop] = useState(false);
    const [dateEarlyTopRange, setDateEarlyTopRange] = useState(0);
    const [displayedEarlyData, setDisplayedEarlyData] = useState([]);

    const [showAllLatestTop, setShowAllLatestTop] = useState(false);
    const [dateLatestTopRange, setDateLatestTopRange] = useState(0);
    const [displayedLatestData, setDisplayedLatestData] = useState([]);

    const [showAllOutTimeTop, setShowAllOutTimeTop] = useState(false);
    const [dateOutTimeTopRange, setDateOutTimeTopRange] = useState(0);
    const [displayedOutTimeData, setDisplayedOutTimeData] = useState([]);

    const [timeRange, setTimeRange] = useState({
        start: dayjs().hour(parseInt(userConstants.startTime.split(':')[0])).minute(parseInt(userConstants.startTime.split(':')[1])),
        end: dayjs().hour(parseInt(userConstants.endTime.split(':')[0])).minute(parseInt(userConstants.endTime.split(':')[1]))
    });
    
    // const today = new Date(endDate);
    // const yesterday = subtractDays(1, today);
    // const startActualWeek = subtractDays(6, today);
    // const endActualWeek = today;
    // const startActualMonth = subtractDays(29, today);
    // const endActualMonth = today;
    // const startPreviousWeek = subtractDays(13, today);
    // const endPreviousWeek = subtractDays(7, today, true);
    // const startPreviousMonth = subtractDays(59, today);
    // const endPreviousMonth = subtractDays(30, today, true);

    const emptyData = {
        all: null,
        earliestFrom: null,
        earliestTo: null,
        latestFrom: null,
        latestTo: null,
    };

    // Mapeo de periodos actuales y previos
    const periodKeyMap = {
        0: { current: 'Hoy', previous: 'Ayer' },
        1: { current: 'Semana actual', previous: 'Semana previa' },
        2: { current: 'Mes actual', previous: 'Mes previo' },
    };

    // Función para convertir 'HH:mm' a Day.js
    const parseTime = (timeStr) => {
        const [hour, minute] = timeStr.split(':').map(Number);
        return dayjs().hour(hour).minute(minute);
    };

    // Función para convertir Day.js a 'HH:mm'
    const formatTimeToDayJs = (dayjsObj) => dayjsObj.format('HH:mm');

    useEffect(() => {
        if (!dataReport || !dataReport[0] || !dataReport[1] || dataReport.length === 0) return;
        setIsLoading(true);

        const processedTripsData = processData(dataReport[0], extractReport0Data, 'trips', startPreviousMonth, endDate);
        const processedEventsData = processData(dataReport[1], extractReport1Data, 'events', startPreviousMonth, endDate);

        const totalTripsData = calculateTotal(processedTripsData, 'trips');
        const totalEventsData = calculateTotal(processedEventsData, 'events');

        setTotalTripsData(totalTripsData);
        setTotalEventsData(totalEventsData);

        updateUserConstants({ "reports.workingTimeTripsData": processedTripsData, "reports.workingTimeEventsData": processedEventsData, "reports.workingTimeTripsTotalData": totalTripsData, "reports.workingTimeEventsTotalData": totalEventsData });

        setIsLoading(false);
    }, [dataReport[0], dataReport[1]]);

    // Inicializar datos acumulados
    const initializeAccumulatedData = () => {
        const periods = ["Hoy", "Ayer", "Semana actual", "Semana previa", "Mes actual", "Mes previo"];
        const data = {};
        periods.forEach(period => {
            data[period] = {};
            devices.forEach(device => {
                data[period][device.label] = { ...emptyData };
            });
        });
        return data;
    };

    const calculateTotal = (processedData, type) => {
        const accumulatedData = initializeAccumulatedData();

        processedData.forEach(dayData => {
            const objDate = new Date(dayData.date);
            Object.keys(dayData).forEach(vehicle => {
                if (vehicle === "date") return; // Ignorar la clave de fecha

                dayData[vehicle].forEach(entry => {

                    const addToPeriod = (period) => {
                        const vehicleData = accumulatedData[period][vehicle];

                        // Inicializar el arreglo `all` si no existe
                        if (!vehicleData.all) {
                            vehicleData.all = [];
                        }

                        // Agregar la entrada completa al arreglo `all`
                        vehicleData.all.push(entry);

                        if (type === 'trips') {
                            const entryFrom = entry.from;
                            const entryTo = entry.to;


                            // Actualizar earliest
                            if (!vehicleData.earliestFrom || new Date(entryFrom).toTimeString() < new Date(vehicleData.earliestFrom).toTimeString()) {
                                vehicleData.earliestFrom = entryFrom;
                                vehicleData.earliestTo = entryTo;
                            }

                            if (!vehicleData.latestFrom || new Date(entryFrom).toTimeString() > new Date(vehicleData.latestFrom).toTimeString()) {
                                vehicleData.latestFrom = entryFrom;
                                vehicleData.latestTo = entryTo;
                            }
                        }

                        if (type === 'events') {

                            const time = entry.time;

                            if (entry.event === 'Ignición Encendida') {
                                if (!vehicleData.earliestFrom || new Date(time).toTimeString() < new Date(vehicleData.earliestFrom).toTimeString()) {
                                    vehicleData.earliestFrom = time;
                                }

                                if (!vehicleData.latestFrom || new Date(time).toTimeString() > new Date(vehicleData.latestFrom).toTimeString()) {
                                    vehicleData.latestFrom = time;
                                }
                            }

                            if (entry.event === 'Ignición Apagada') {
                                if (!vehicleData.earliestTo || new Date(time).toTimeString() < new Date(vehicleData.earliestTo).toTimeString()) {
                                    vehicleData.earliestTo = time;
                                }

                                if (!vehicleData.latestTo || new Date(time).toTimeString() > new Date(vehicleData.latestTo).toTimeString()) {
                                    vehicleData.latestTo = time;
                                }
                            }
                        }

                    };

                    if (objDate.toDateString() === today.toDateString()) {
                        addToPeriod("Hoy");
                    } else if (objDate.toDateString() === yesterday.toDateString()) {
                        addToPeriod("Ayer");
                    }

                    if (objDate >= startActualWeek && objDate <= today) {
                        addToPeriod("Semana actual");
                    }

                    if (objDate >= startActualMonth && objDate <= today) {
                        addToPeriod("Mes actual");
                    }

                    if (objDate >= startPreviousWeek && objDate <= endPreviousWeek) {
                        addToPeriod("Semana previa");
                    }

                    if (objDate >= startPreviousMonth && objDate <= endPreviousMonth) {
                        addToPeriod("Mes previo");
                    }
                });
            });

        });

        return accumulatedData;
    };

    useEffect(() => {
        const totalTripsData = calculateTotal(userConstants.reports.workingTimeTripsData, 'trips');
        const totalEventsData = calculateTotal(userConstants.reports.workingTimeEventsData, 'events');

        setTotalTripsData(totalTripsData);
        setTotalEventsData(totalEventsData);
    }, [today, yesterday, startActualWeek, endActualWeek, startPreviousWeek, endPreviousWeek]);

    const [cardsReady, setCardsReady] = useState([]);

    useEffect(() => {
        const totalCards = 3; // Cambiar este número según la cantidad de tarjetas
        if (progress[0] === 100 && progress[1] === 100) {
            // Generar tiempos aleatorios para cada tarjeta
            const randomDelays = Array.from({ length: totalCards }, () => Math.random() * 2000 + 1000); // 1-3 segundos
            const timeouts = randomDelays.map((delay, index) => {
                return setTimeout(() => {
                    setCardsReady((prev) => {
                        const updated = [...prev];
                        updated[index] = true;
                        return updated;
                    });
                }, delay);
            });

            // Limpiar los timeouts al desmontar
            return () => timeouts.forEach((timeout) => clearTimeout(timeout));
        } else {
            setCardsReady(new Array(totalCards).fill(false));
        }
    }, [progress]);

    const getDataByDateRange = (range) => {
        let periodCurrentDataTrips = {}, periodPreviousDataTrips = {}, periodCurrentDataEvents = {}, periodPreviousDataEvents = {};

        // Determinar los períodos actuales y previos
        switch (range) {
            case 0:
                periodCurrentDataTrips = totalTripsData['Hoy'] || {};
                periodPreviousDataTrips = totalTripsData['Ayer'] || {};
                periodCurrentDataEvents = totalEventsData['Hoy'] || {};
                periodPreviousDataEvents = totalEventsData['Ayer'] || {};
                break;
            case 1:
                periodCurrentDataTrips = totalTripsData['Semana actual'] || {};
                periodPreviousDataTrips = totalTripsData['Semana previa'] || {};
                periodCurrentDataEvents = totalEventsData['Semana actual'] || {};
                periodPreviousDataEvents = totalEventsData['Semana previa'] || {};
                break;
            case 2:
                periodCurrentDataTrips = totalTripsData['Mes actual'] || {};
                periodPreviousDataTrips = totalTripsData['Mes previo'] || {};
                periodCurrentDataEvents = totalEventsData['Mes actual'] || {};
                periodPreviousDataEvents = totalEventsData['Mes previo'] || {};
                break;
            default:
                return [];
        }

        // Filtrar dispositivos visibles
        const visibleDevices = devices.filter(device => device.visible);

        // Combinar y mapear datos
        const combinedData = Object.keys({ ...periodCurrentDataTrips, ...periodPreviousDataTrips, ...periodCurrentDataEvents, ...periodPreviousDataEvents })
            .filter(car => visibleDevices.find(device => device.label === car)) // Filtrar por visibilidad
            .map((car) => {
                const currentTrips = periodCurrentDataTrips[car] || { ...emptyData };
                const previousTrips = periodPreviousDataTrips[car] || { ...emptyData };
                const currentEvents = periodCurrentDataEvents[car] || { ...emptyData };
                const previousEvents = periodPreviousDataEvents[car] || { ...emptyData };

                return {
                    vehicle: car,
                    currentAllTrips: currentTrips.all,
                    previousAllTrips: previousTrips.all,
                    earliestCurrentFromTrips: currentTrips.earliestFrom ? new Date(currentTrips.earliestFrom) : null,
                    earliestCurrentToTrips: currentTrips.earliestTo ? new Date(currentTrips.earliestTo) : null,
                    earliestPreviousFromTrips: previousTrips.earliestFrom ? new Date(previousTrips.earliestFrom) : null,
                    earliestPreviousToTrips: previousTrips.earliestTo ? new Date(previousTrips.earliestTo) : null,

                    latestCurrentFromTrips: currentTrips.latestFrom ? new Date(currentTrips.latestFrom) : null,
                    latestCurrentToTrips: currentTrips.latestTo ? new Date(currentTrips.latestTo) : null,
                    latestPreviousFromTrips: previousTrips.latestFrom ? new Date(previousTrips.latestFrom) : null,
                    latestPreviousToTrips: previousTrips.latestTo ? new Date(previousTrips.latestTo) : null,

                    currentAllEvents: currentEvents.all,
                    previousAllEvents: previousEvents.all,
                    earliestCurrentFromEvents: currentEvents.earliestFrom ? new Date(currentEvents.earliestFrom) : null,
                    earliestCurrentToEvents: currentEvents.earliestTo ? new Date(currentEvents.earliestTo) : null,
                    earliestPreviousFromEvents: previousEvents.earliestFrom ? new Date(previousEvents.earliestFrom) : null,
                    earliestPreviousToEvents: previousEvents.earliestTo ? new Date(previousEvents.earliestTo) : null,

                    latestCurrentFromEvents: currentEvents.latestFrom ? new Date(currentEvents.latestFrom) : null,
                    latestCurrentToEvents: currentEvents.latestTo ? new Date(currentEvents.latestTo) : null,
                    latestPreviousFromEvents: previousEvents.latestFrom ? new Date(previousEvents.latestFrom) : null,
                    latestPreviousToEvents: previousEvents.latestTo ? new Date(previousEvents.latestTo) : null
                };
            });

        return combinedData;
    };

    // Ordenamiento y uso en useEffect
    useEffect(() => {
        const sortedEarlyData = getDataByDateRange(dateEarlyTopRange)
            .map(item => {
                if (item.earliestCurrentFromEvents) {
                    const earliestEventTime = item.earliestCurrentFromEvents.getTime();
                    const validTrips = (item.currentAllTrips || []).filter(trip => new Date(trip.from).getTime() > earliestEventTime);
                    if (validTrips.length > 0) {
                        validTrips.sort((a, b) => new Date(a.from) - new Date(b.from));
                        item.earliestCurrentFromTrips = new Date(validTrips[0].from);
                    }
                }
                return item;
            })
            .sort((a, b) => {
                const timeA = a.earliestCurrentFromTrips ? a.earliestCurrentFromTrips.toTimeString().split(' ')[0] : '';
                const timeB = b.earliestCurrentFromTrips ? b.earliestCurrentFromTrips.toTimeString().split(' ')[0] : '';

                // Si uno de los valores es null, enviarlo al final
                if (timeA === '' && timeB !== '') return 1;
                if (timeB === '' && timeA !== '') return -1;

                // Comparar horas de earliestCurrent en orden ascendente
                if (timeA > timeB) return 1;
                if (timeA < timeB) return -1;

                // En caso de igualdad, comparar earliestPrevious
                const prevTimeA = a.earliestPreviousFromTrips ? a.earliestPreviousFromTrips.toTimeString().split(' ')[0] : '';
                const prevTimeB = b.earliestPreviousFromTrips ? b.earliestPreviousFromTrips.toTimeString().split(' ')[0] : '';

                if (prevTimeA > prevTimeB) return 1;
                if (prevTimeA < prevTimeB) return -1;

                return 0; // Igualdad
            });

        setDisplayedEarlyData(showAllEarlyTop ? sortedEarlyData : sortedEarlyData.slice(0, 5));
    }, [devices, dateEarlyTopRange, totalTripsData, totalEventsData, showAllEarlyTop]);

    useEffect(() => {
        const sortedLatestData = getDataByDateRange(dateLatestTopRange)
            .sort((a, b) => {
                const timeA = a.earliestCurrentFromTrips ? a.earliestCurrentFromTrips.toTimeString().split(' ')[0] : '';
                const timeB = b.earliestCurrentFromTrips ? b.earliestCurrentFromTrips.toTimeString().split(' ')[0] : '';

                // Comparar horas de earliestCurrent en orden descendente
                if (timeA < timeB) return 1;
                if (timeA > timeB) return -1;

                // En caso de igualdad, comparar earliestPrevious en orden descendente
                const prevTimeA = a.earliestPreviousFromTrips ? a.earliestPreviousFromTrips.toTimeString().split(' ')[0] : '';
                const prevTimeB = b.earliestPreviousFromTrips ? b.earliestPreviousFromTrips.toTimeString().split(' ')[0] : '';

                if (prevTimeA < prevTimeB) return 1;
                if (prevTimeA > prevTimeB) return -1;

                const earliestTimeA = a.earliestCurrentToTrips ? a.earliestCurrentToTrips.toTimeString().split(' ')[0] : '';
                const earliestTimeB = b.earliestCurrentToTrips ? b.earliestCurrentToTrips.toTimeString().split(' ')[0] : '';

                if (earliestTimeA < earliestTimeB) return 1;
                if (earliestTimeA > earliestTimeB) return -1;

                return 0; // Igualdad
            });

        setDisplayedLatestData(showAllLatestTop ? sortedLatestData : sortedLatestData.slice(0, 5));
    }, [devices, dateLatestTopRange, totalTripsData, totalEventsData, showAllLatestTop]);

    const formatTime = (timeStr) => {
        // Asegurar que `timeStr` sea una cadena en formato "HH:mm"
        const timeString = typeof timeStr === 'string' ? timeStr : dayjs(timeStr).format("HH:mm");
        const [hour, minute] = timeString.split(':').map(Number);
        return hour * 60 + minute;
    };


    const isOnRange = (timeStr) => {
        const time = formatTime(timeStr);
        const startTime = formatTime(timeRange.start);
        const endTime = formatTime(timeRange.end);

        if (startTime > endTime) {
            return (time <= 1439 && time >= startTime) || (time >= 0 && time <= endTime);
        }

        return time >= startTime && time <= endTime;
    };

    const countOnTime = (entries, type) => {
        return entries.filter(entry => {
            const timeToCheck = type === 'trips' ? entry.from : (entry.event === 'Ignición Encendida' ? entry.time : null);
            return timeToCheck && isOnRange(new Date(timeToCheck).toTimeString().split(':').slice(0, 2).join(':'));
        }).length;
    };

    const isAllZero = (data) => {
        return data.currentBeforeStart === 0 && data.currentAfterEnd === 0 && data.previousBeforeStart === 0 && data.previousAfterEnd === 0;
    };

    useEffect(() => {
        const updatedOutTimeData = getDataByDateRange(dateOutTimeTopRange)
            .map(vehicleData => {
                const currentOnRangeTrips = countOnTime(vehicleData.currentAllTrips || [], 'trips');
                const previousOnRangeTrips = countOnTime(vehicleData.previousAllTrips || [], 'trips');

                const currentOnRangeEvents = countOnTime(vehicleData.currentAllEvents || [], 'events');
                const previousOnRangeEvents = countOnTime(vehicleData.previousAllEvents || [], 'events');

                return {
                    ...vehicleData,
                    currentOnRangeTrips,
                    previousOnRangeTrips,

                    currentOnRangeEvents,
                    previousOnRangeEvents
                };
            })
            .sort((a, b) => {
                const aAllZero = isAllZero(a);
                const bAllZero = isAllZero(b);

                if (aAllZero && !bAllZero) return 1;
                if (!aAllZero && bAllZero) return -1;

                if (b.currentOnRangeTrips !== a.currentOnRangeTrips) {
                    return b.currentOnRangeTrips - a.currentOnRangeTrips;
                }
                if (b.previousOnRangeTrips !== a.previousOnRangeTrips) {
                    return b.previousOnRangeTrips - a.previousOnRangeTrips;
                }
                return b.currentOnRangeEvents - a.currentOnRangeEvents;
            });

        setDisplayedOutTimeData(showAllOutTimeTop ? updatedOutTimeData : updatedOutTimeData.slice(0, 5));
    }, [devices, dateOutTimeTopRange, totalTripsData, totalEventsData, showAllOutTimeTop, timeRange]);

    const totalItems = displayedEarlyData.length;

    // Calcular el ancho basado en la cantidad de dígitos
    const indexWidth = totalItems < 10 ? '2ch' : totalItems < 100 ? '3ch' : '4ch';

    return (
        <div className='section_grid_container'>
            <div className='dashboard_card card_top_large card_short'>
                {error ?
                    <RetryReport fetchReport={fetchReport} sectionNum={5} />
                    :
                    progress[0] < 100 || progress[1] < 100 || !cardsReady[0] ? (
                        <Loader progress={(progress[0] + progress[1]) / 2} />
                    ) : (
                        <>
                            <div className='card_header_flex'>
                                <div className='dashboard_card_header_container'>
                                    <span className='dashboard_card_title'>{showAllEarlyTop ? 'Todas las' : 'Top 5'} horas más tempranas de trabajo de los vehículos</span>
                                    <button className='dashboard_card_view_more' onClick={() => setShowAllEarlyTop((prev) => !prev)}>
                                        {showAllEarlyTop ? 'Ver menos' : 'Ver todos'}
                                    </button>
                                </div>
                                <div className='card_config_container'>
                                    <DateRangeSelector dateRange={dateEarlyTopRange} setDateRange={setDateEarlyTopRange} />
                                </div>
                            </div>

                            <div className='dashboard_card_content_container'>
                                <div className='top_items_container' style={{ '--item-index-width': indexWidth, marginTop: 0 }}>
                                    <div className='top_items_header_container many_items'>
                                        <span style={{ marginTop: 'auto' }}>Periodo</span>
                                        <div>
                                            <span>Por viajes</span>
                                            <br />
                                            <span>Actual<br/><span>({formatDateRange(dateEarlyTopRange, today, startActualWeek, endActualWeek, startActualMonth, endActualMonth)})</span></span>
                                            <span>Previo<br/><span>({formatDateRange(dateEarlyTopRange, yesterday, startPreviousWeek, endPreviousWeek, startPreviousMonth, endPreviousMonth)})</span></span>
                                        </div>
                                        <div>
                                            <span>Por ignición</span>
                                            <br />
                                            <span>Actual<br/><span>({formatDateRange(dateEarlyTopRange, today, startActualWeek, endActualWeek, startActualMonth, endActualMonth)})</span></span>
                                            <span>Previo<br/><span>({formatDateRange(dateEarlyTopRange, yesterday, startPreviousWeek, endPreviousWeek, startPreviousMonth, endPreviousMonth)})</span></span>
                                        </div>
                                    </div>
                                    {
                                        displayedEarlyData.length === 0 ?
                                            <span className='text_no_vehicles'>Ningún vehículo seleccionado</span>
                                            :
                                            displayedEarlyData.map((item, index) => (
                                                <ItemList
                                                    key={index}
                                                    index={index + 1}
                                                    type={'working_time'}
                                                    name={item.vehicle}
                                                    data={{
                                                        currentFromTrips: item.earliestCurrentFromTrips,
                                                        previousFromTrips: item.earliestPreviousFromTrips,
                                                        currentFromEvents: item.earliestCurrentFromEvents,
                                                        previousFromEvents: item.earliestPreviousFromEvents
                                                    }}
                                                />
                                            ))
                                    }
                                </div>
                            </div>
                        </>
                    )}
            </div>
            <div className='dashboard_card card_top_large card_short'>
                {error ?
                    <RetryReport fetchReport={fetchReport} sectionNum={5} />
                    :
                    progress[0] < 100 || progress[1] < 100 || !cardsReady[1] ? (
                        <Loader progress={(progress[0] + progress[1]) / 2} />
                    ) : (
                        <>
                            <div className='card_header_flex'>
                                <div className='dashboard_card_header_container'>
                                    <span className='dashboard_card_title'>{showAllLatestTop ? 'Todas las' : 'Top 5'} horas más tardías de trabajo de los vehículos</span>
                                    <button className='dashboard_card_view_more' onClick={() => setShowAllLatestTop((prev) => !prev)}>
                                        {showAllLatestTop ? 'Ver menos' : 'Ver todos'}
                                    </button>
                                </div>
                                <div className='card_config_container'>
                                    <DateRangeSelector dateRange={dateLatestTopRange} setDateRange={setDateLatestTopRange} />
                                </div>
                            </div>

                            <div className='dashboard_card_content_container'>
                                <div className='top_items_container' style={{ '--item-index-width': indexWidth, marginTop: 0 }}>
                                    <div className='top_items_header_container many_items'>
                                        <span style={{ marginTop: 'auto' }}>Periodo</span>
                                        <div>
                                            <span>Por viajes</span>
                                            <br />
                                            <span>Actual<br/><span>({formatDateRange(dateLatestTopRange, today, startActualWeek, endActualWeek, startActualMonth, endActualMonth)})</span></span>
                                            <span>Previo<br/><span>({formatDateRange(dateLatestTopRange, yesterday, startPreviousWeek, endPreviousWeek, startPreviousMonth, endPreviousMonth)})</span></span>
                                        </div>
                                        <div>
                                            <span>Por ignición</span>
                                            <br />
                                            <span>Actual<br/><span>({formatDateRange(dateLatestTopRange, today, startActualWeek, endActualWeek, startActualMonth, endActualMonth)})</span></span>
                                            <span>Previo<br/><span>({formatDateRange(dateLatestTopRange, yesterday, startPreviousWeek, endPreviousWeek, startPreviousMonth, endPreviousMonth)})</span></span>
                                        </div>
                                    </div>
                                    {
                                        displayedLatestData.length === 0 ?
                                            <span className='text_no_vehicles'>Ningún vehículo seleccionado</span>
                                            :
                                            displayedLatestData.map((item, index) => (
                                                <ItemList
                                                    key={index}
                                                    index={index + 1}
                                                    type={'working_time'}
                                                    name={item.vehicle}
                                                    data={{
                                                        currentFromTrips: item.earliestCurrentFromTrips,
                                                        previousFromTrips: item.earliestPreviousFromTrips,
                                                        currentFromEvents: item.earliestCurrentFromEvents,
                                                        previousFromEvents: item.earliestPreviousFromEvents
                                                    }}
                                                />
                                            ))
                                    }
                                </div>
                            </div>
                        </>
                    )}
            </div>
            <div className='dashboard_card card_top_large card_short'>
                {error ?
                    <RetryReport fetchReport={fetchReport} sectionNum={5} />
                    :
                    progress[0] < 100 || progress[1] < 100 || !cardsReady[2] ? (
                        <Loader progress={(progress[0] + progress[1]) / 2} />
                    ) : (
                        <>
                            <div className='card_header_flex'>
                                <div className='dashboard_card_header_container'>
                                    <span className='dashboard_card_title'>{showAllOutTimeTop ? 'Todos los' : 'Top 5'} vehículos fuera del horario de actividades (incidencias)</span>
                                    <button className='dashboard_card_view_more' onClick={() => setShowAllOutTimeTop((prev) => !prev)}>
                                        {showAllOutTimeTop ? 'Ver menos' : 'Ver todos'}
                                    </button>
                                </div>
                                <div className='card_config_container'>
                                    <DateRangeSelector dateRange={dateOutTimeTopRange} setDateRange={setDateOutTimeTopRange} />
                                </div>
                            </div>
                            <div className='time_pickers_container'>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <TimePicker
                                        label="Hora inicial"
                                        value={timeRange.start}
                                        onChange={(newValue) => {
                                            if (newValue && newValue.isValid()) {
                                                const formattedTime = newValue.format('HH:mm');
                                                updateUserConstants({ startTime: formattedTime });
                                                setTimeRange(prev => ({ ...prev, start: newValue }));
                                            }
                                        }}
                                        
                                        slotProps={{
                                            textField: {
                                                variant: "outlined",
                                                sx: {
                                                    fontSize: "12px", // Reducir tamaño de fuente
                                                    "& input": {
                                                        fontSize: "0.7rem", // Tamaño del texto dentro del input
                                                        padding: "12px 8px", // Reducir padding dentro del input
                                                    },
                                                }
                                            }
                                        }}
                                    />

                                    {/* {console.log(timeRange)} */}
                                    <TimePicker
                                        label="Hora final"
                                        value={timeRange.end}
                                        onChange={(newValue) => {
                                            if (newValue && newValue.isValid()) {
                                                const formattedTime = newValue.format('HH:mm');
                                                updateUserConstants({ endTime: formattedTime });
                                                setTimeRange(prev => ({ ...prev, end: newValue }));
                                            }
                                        }}
                                        
                                        slotProps={{
                                            textField: {
                                                variant: "outlined",
                                                sx: {
                                                    fontSize: "12px", // Reducir tamaño de fuente
                                                    "& input": {
                                                        fontSize: "0.7rem", // Tamaño del texto dentro del input
                                                        padding: "12px 8px", // Reducir padding dentro del input
                                                    },
                                                }
                                            }
                                        }}
                                    />
                                </LocalizationProvider>


                                {/* <label>
                                    Hora inicial:
                                    <input
                                        type='time'
                                        value={timeRange.start}
                                        onChange={(e) => { updateUserConstants({ ...userConstants, startTime: e.target.value }); setTimeRange((prev) => ({ ...prev, start: e.target.value })); }}
                                        style={{
                                            margin: '0 10px',
                                            padding: '5px',
                                            border: '1px solid #ccc',
                                            borderRadius: '4px',
                                            backgroundColor: '#f9f9f9'
                                        }}
                                    />
                                </label>
                                <label>
                                    Hora final:
                                    <input
                                        type='time'
                                        value={timeRange.end}
                                        onChange={(e) => { updateUserConstants({ ...userConstants, endTime: e.target.value }); setTimeRange((prev) => ({ ...prev, end: e.target.value })); }}
                                        style={{
                                            margin: '0 10px',
                                            padding: '5px',
                                            border: '1px solid #ccc',
                                            borderRadius: '4px',
                                            backgroundColor: '#f9f9f9'
                                        }}
                                    />
                                </label> */}
                            </div>
                            <div className='dashboard_card_content_container'>
                                <div className='top_items_container' style={{ '--item-index-width': indexWidth, marginTop: 0 }}>
                                    <div className='top_items_header_container many_items'>
                                        <span style={{ marginTop: 'auto' }}>Periodo</span>
                                        <div>
                                            <span>Por viajes</span>
                                            <br />
                                            <span>Actual<br/><span>({formatDateRange(dateOutTimeTopRange, today, startActualWeek, endActualWeek, startActualMonth, endActualMonth)})</span></span>
                                            <span>Previo<br/><span>({formatDateRange(dateOutTimeTopRange, yesterday, startPreviousWeek, endPreviousWeek, startPreviousMonth, endPreviousMonth)})</span></span>
                                        </div>
                                        <div>
                                            <span>Por ignición</span>
                                            <br />
                                            <span>Actual<br/><span>({formatDateRange(dateOutTimeTopRange, today, startActualWeek, endActualWeek, startActualMonth, endActualMonth)})</span></span>
                                            <span>Previo<br/><span>({formatDateRange(dateOutTimeTopRange, yesterday, startPreviousWeek, endPreviousWeek, startPreviousMonth, endPreviousMonth)})</span></span>
                                        </div>
                                    </div>
                                    {
                                        displayedOutTimeData.length === 0 ?
                                            <span className='text_no_vehicles'>Ningún vehículo seleccionado</span>
                                            :
                                            displayedOutTimeData.map((item, index) => (
                                                <ItemList
                                                    key={index}
                                                    index={index + 1}
                                                    type={'out_time'}
                                                    name={item.vehicle}
                                                    data={{
                                                        currentOnRangeTrips: item.currentOnRangeTrips,
                                                        previousOnRangeTrips: item.previousOnRangeTrips,
                                                        currentOnRangeEvents: item.currentOnRangeEvents,
                                                        previousOnRangeEvents: item.previousOnRangeEvents
                                                    }}
                                                />
                                            ))
                                    }
                                </div>
                            </div>
                        </>
                    )}
            </div>
        </div>
    )
}

export default WorkingTime
